import {h, Fragment} from "preact"
export default function CornerTreatment({ product }) {

    const isVirtualGiftCard = () => {
        return (
            product.categories?.includes('Gift Cards') || 
            product.tags1?.includes('digital-product') && product.categories?.includes('Gift Cards') ||
            product.tags1?.includes('EasyGift All Products')
        );
    };
    
    const getCornerTreatment = () => {
        if (product.categories.includes('Coming Soon Collection')) {
            return { text: "coming soon" };
        } else if (product.inventoryLevel < 50 && !isVirtualGiftCard()) {
            return { text: "Almost Gone" };
        } else if (product.tags1.includes('Bestsellers')) {
            return { text: "bestseller" };
        } else if (product.tags1.includes('ExclusivePrint')) {
            return { text: "exclusive print" };
        }
        return null; 
    };

    const cornerTreatments = getCornerTreatment();
    const productAvailable = product?.available;
    const categoryComingSoon = product?.categories?.includes('Coming Soon Collection');

    return (
       <>
                {cornerTreatments && (productAvailable || categoryComingSoon) && (
                    <div class="pd-corner-treatment">
                        {cornerTreatments.text}
                    </div>
                )}
               
       </>
    );
}
